import ColorPicker from './compoments/colorpicker';

function App() {
  return (
      <ColorPicker/>
  );
}
export default App;
